import { AppBar, Toolbar, Typography } from "@mui/material";
import colorConfigs from "../../configs/colorConfigs";
import sizeConfigs from "../../configs/sizeConfigs";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCaretRight } from '@fortawesome/free-regular-svg-icons';


const Topbar = () => {
  return (
    <AppBar
      position="fixed"
      sx={{
        width: `calc(100% - ${sizeConfigs.sidebar.width})`,
        height: 60,
        ml: sizeConfigs.sidebar.width,
        boxShadow: "unset",
        background: colorConfigs.topbar.bg,
        color: colorConfigs.topbar.color
      }}
    >
      <Toolbar 
      style={{justifyContent:"space-between"}}>
      <Typography
          variant="h6"
          fontSize={14}
          fontWeight={400}
          textAlign={"center"}
          marginTop={-1}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)", // Text shadow effect
          }}
        >
          <FontAwesomeIcon
            icon={faSquareCaretRight}
            size="lg"
            style={{ marginRight: "4px" }}
          />
          Manage Campaigns
        </Typography>
        <div 
        style={{
          fontSize:'10px',
           padding:'0px 14px',
           height:'40px',
           width:'240px',
           backgroundColor:'#194772',
           display:'flex',
           justifyContent:'space-between',
           marginTop:'-10px',
           borderRadius:'4px',
           overflow:'hidden'
        }}>
          <p style={{fontSize:'14px', color:'hsl(0, 1.80%, 89.20%)', marginTop:'8px'}}>Current Balance</p>
          <p style={{fontSize:'14px', color:'hsl(0, 1.80%, 89.20%)',marginTop:'8px'}}>$17,000.0</p>
      </div>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;